import { BASE_URL } from "./constants";
import axios, { AxiosResponse, AxiosError } from "axios";
import type { InternalAxiosRequestConfig } from "axios";
import { toast } from "react-toastify";

const API = axios.create({
  baseURL: `${BASE_URL}/`
});

// Add a request interceptor
API.interceptors.request.use(
  function (config: InternalAxiosRequestConfig) {
    // Do something before request is sent
    const token = localStorage.getItem("token");
    if (token && config.headers) {
      (config.headers as any)["Authorization"] = token;
    }
    if (config.headers) {
      (config.headers as any)["Content-Type"] = "application/json";
    }
    return config;
  },
  function (error: AxiosError) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  function (response: AxiosResponse) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // If response.data.data exists, return it, else return response.data
    return response.data?.data ?? response.data;
  },
  function (error: AxiosError) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.config.url !== "dev/auth"
    ) {
      localStorage.removeItem("token");
      toast.error("Session Expire");
      window.location.reload();
    }

    // Handle for multiple errors
    if (!error.response) {
      return Promise.reject("Something went wrong!");
    } else if ((error.response.data as any)?.errors) {
      return Promise.reject(error.response.data);
    } else if (
      error?.response?.status === 403 ||
      (error?.response?.data as any)?.msg
    ) {
      return Promise.reject((error.response.data as any).msg);
    } else if ((error?.response?.data as any)?.message) {
      return Promise.reject((error.response.data as any).message);
    } else {
      return Promise.reject((error.response.data as any).error);
    }
  }
);

export { API };
